<template>
  <div class="redenvelope" :class="{'version':version && !isInRoom}">
    <div class="version" v-if="version && !isInRoom">您的客户端版本较低，<span @click="toupgrade">点击此处</span>更新后方可解锁抢红包功能</div>
    <!-- 返回 -->
    <!-- <button class="back" @click="closeDraw" v-if="!isInRoom"></button> -->
    <!-- 关闭 -->
    <button class="rule" @click="showpopEvent('rule')" :class="{'rule_apk' : isInRoom}" @touchstart.stop.prevent="showpopEvent('rule')"></button>
    <!-- <button class="close" v-if="isInRoom" @click="closeWindow"></button> -->
    <!-- 活动时间 -->
    <!-- <p class="time"><span>9月30日 - 10月07日</span></p> -->
    <!-- slogan -->
    <div class="slogan">
      <img src="@/assets/img/red/pic-prize.png">

      <div class="daily_desc" v-if="reward_host">
        <div>
          <p class="daily_title">今日已领取时长</p>
          <p class="daily_online"><i class="icon icon_mobile"></i>手游 <span>{{ task_daily.member_award_mobile_time }}</span> 分钟</p>
          <p class="daily_online"><i class="icon icon_pc"></i>端游 <span>{{ task_daily.member_award_pc_time }}</span> 分钟</p>
        </div>

        <div>
          <p class="daily_title">今日房主奖励时长</p>
          <p class="daily_online"><i class="icon icon_mobile"></i>手游 <span>{{ task_daily.host_award_mobile_time }}</span> 分钟</p>
          <p class="daily_online"><i class="icon icon_pc"></i>端游 <span>{{ task_daily.host_award_pc_time }}</span> 分钟</p>
        </div>
      </div>

      <div class="daily_desc" v-else-if="reward_daily">
        <div class="daily_title_only"><span style="width:58px;display: inline-block;text-align: center;">今日</span><br>已领取奖励</div>
        <div>
          <p class="daily_online"><i class="icon icon_mobile"></i>手游 <span>{{ task_daily.member_award_mobile_time }}</span> 分钟</p>
          <p class="daily_online"><i class="icon icon_pc"></i>端游 <span>{{ task_daily.member_award_pc_time }}</span> 分钟</p>
        </div>        
      </div>

    </div>

    <!-- 抢红包 -->
    <div class="daily_btn" :class="{'daily_btn_apk' : isInRoom, 'reward_none' : !reward_host && !reward_daily}">
      <p>今日剩余红包开启机会 <span>{{ task_daily.user_opportunity_left_num }}</span> 次</p>
      <button v-if="!isInRoom" @click="toplay('to')">去抢红包</button>
    </div>

    <!-- big - tab -->
    <div class="live_tab" :class="{'live_tab_apk' : isInRoom}">    
      <ul>
        <template v-for="item in redTab">
          <li :class="{ on : curRedTab == item.type }" :key="item.key" @click="changeType(item.type)">{{ item.name }}</li>
        </template>
      </ul>
    </div>

    <!-- 红包任务 -->
    <div v-if="curRedTab === 'task'" class="task_box">
      <div class="task_in_box flex justify alignitem">
        <div><p>进入一起玩房间</p></div>
        <button :class="[ task_daily.watch_room_time_seconds > 0 ? 'btn_wc_disabled' : 'btn_wc']" @click="toplay(!task_daily.watch_room_time_seconds)"></button>
      </div>

      <!-- 上麦 -->
      <div class="task_in_box flex justify" :class="{'alignitem' : !task_micro}">
        <div>
          <p>上麦5分钟</p>
          <p class="task_tips" v-if="task_micro">还差{{ task_micro }}分钟</p>
        </div>        
        <button :class="[ task_micro ? 'btn_wc' : 'btn_wc_disabled']" @click="toplay(task_micro)"></button>
      </div>

      <!-- 发言 -->
      <div class="task_in_box">
        <div class="flex justify" :class="{'alignitem' : !task_chat}">
          <div>
            <p @click="showpopEvent('tips')">一起玩房间内累计发言<i class="icon icon_q"></i></p>
            <p class="task_tips" v-if="task_chat">还差{{ task_chat }}次发言</p></div>
          <button :class="[ task_chat ? 'btn_wc' : 'btn_wc_disabled']" @click="toplay(task_chat)">去完成</button>
        </div>
        <div class="task_jdt">
          <div class="task_jdt_in" :style="tack_chat_jdt"></div>
          <ul class="flex justify">
            <li v-for="item in chat_num" :key="item.key" :class="{'on' : task_daily.on_chat_num >= item}">
              <p>{{ item }}<span>次</span></p>
            </li>
          </ul>          
        </div>
        
      </div>

      <!-- 累计观看 -->
      <div class="task_in_box">
        <div class="flex justify" :class="{'alignitem' : !task_watch}">
          <div>
            <p>一起玩房间内累计观看</p>
            <p class="task_tips" v-if="task_watch">还差{{ task_watch }}分钟观看时长</p>
          </div>
          <button :class="[ task_watch ? 'btn_wc' : 'btn_wc_disabled']" @click="toplay(task_watch)">去完成</button>
        </div>
        <div class="task_jdt">
          <div class="task_jdt_in" :style="task_wtach_jdt"></div>
          <ul class="flex justify">
            <li v-for="item in watch_min" :key="item.key" :class="{'on' : task_daily.watch_room_time_seconds/60 >= item}">
              <p>{{ item }}<span>min</span></p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 达人榜 -->
    <rank 
      v-if="curRedTab === 'rank'" 
      :isInRoom="isInRoom"
      @toplay="toplay"
    ></rank>

    <div class="mask" v-if="showpop.mask"></div>

    <div class="pop flex justifycenter alignitem" v-if="showpop.tips" @click="showpopEvent()">
      <div class="pop_tips">该数据可能存在5分钟左右延时</div>
    </div>

    <div class="pop flex justifycenter alignitem" v-if="showpop.rule">
      <div class="pop_rule">
        <button class="pop_close" @click="showpopEvent()" @touchstart.stop.prevent="showpopEvent()"></button>
        <div class="pop_rule_title"></div>
        <div class="pop_rule_in">
1.在活动时间内，一起玩全部房间 (或特定房间) 满足条件就会掉落时长红包，房主获得专属时长，玩家做任务赢抢红包资格！<br><br>

2.一起玩全部房间 (或特定房间) ，满足未设置密码且开启游戏的房间会进入红包倒计时流程，计时结束，掉落时长红包。<br><br>

3.用户点击领取时长红包即可获得端内游戏时长。<br><br>

4.房主时长获取规则：<br>
（1）房间内每掉落一次红包，会根据当前游戏类型为房主派发手游时长或端游时长，当日内无次数限制；<br>
（2）若房主为手游VIP用户，时长将替换为等值端游时长；<br><br>

5.房客时长红包抽取规则：<br>
（1）玩家通过进入一起玩、观看时长累积、发言次数累积、上麦游戏等方式获得抢红包次数；<br>
（2）用户当日最多可获得9次抽奖机会，玩家抢红包次数可能存在短时延时到账；<br>
（3）每位玩家的累计次数在每日24:00时清零，即在次日0:00开启新一日的统计；<br>
（4）玩家通过抽取红包获得时长，时长类型与房间当前游戏相关；<br>
（5）若玩家获得手游时长且玩家为手游VIP用户则以 (手游时长*2/3)兑换为端游时长，向上取整；<br>
（6）若玩家本次红包未抢到，不消耗抢红包次数。<br><br>

6.计时规则：<br>
（1）从房间开启游戏进入计时流程；<br>
（2）从开始计时起，当开房累计时间&lt;=120分钟时，房间内每30分钟掉落一次红包，即累计满30，60，90，120分钟掉落红包；<br>
（3）当累计时间>120分钟时，房间内每20分钟掉落一次红包，即累计满140，160，180，200…1440分钟掉落红包。<br><br>

7.榜单刷新规则：<br>
（1）时长领取会实时刷新；<br>
（2）日榜及总榜会每日24:00刷新当日榜单；<br>
（3）日榜及总榜均统计的是玩家开房房间内掉落时长累加。<br>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import api from '@/api/index';
import pagebus from '@/utils/pagebus';
import rank from '@/components/red/rank.vue'
import _ from '@/utils/util'
export default {
  name: 'redenvelope',
  data () {
    return {
      redTab: [
        {
          type: 'task',
          name: '红包任务'
        },
        {
          type: 'rank',
          name: '达人榜'
        }
      ],
      curRedTab: 'task',      
      showpop: {},
      task_daily: {},
      isInRoom: false,     //是否在房间内
      chat_num: [1, 2, 10],
      watch_min: [10, 20, 35, 65]
    }
  },
  components:{
    rank
  },
  computed: {
    ...mapGetters([
      'neteasecloud',
      'devInfo'
    ]),
    reward_host () {
      // 房主奖励 - 返回分钟
      return this.task_daily.host_award_mobile_time || this.task_daily.host_award_pc_time // 房主奖励
    },
    reward_daily () {
      // 今日奖励 - 返回分钟
      return this.task_daily.member_award_mobile_time || this.task_daily.member_award_pc_time // 今日奖励
    },
    task_micro () {
      // 上麦 - 返回秒      
      const on_chat = this.task_daily.on_micro_time_seconds/60 
      const left = on_chat >= 5 ? false : (5 - on_chat)
      return Math.floor(left * 100) / 100
    },
    task_chat () {      
      // 发言
      const chat = this.task_daily.on_chat_num
      if (chat >= 10) {
        return false
      } else if (chat >= 2){
        return 10 - chat
      } else if (chat >= 1){
        return 1
      } else {
        return 1
      }
    },
    tack_chat_jdt () {
      // 发言进度条
      const num = this.task_daily.on_chat_num
      let levaf
      if (num > 2 && num < 10) {
        levaf = num * 30 / 8
      }
      return num >= 10 ? 'width: 100%' : (num == 2 ? 'width: 50%' : `width: ${levaf + 50}%`)
    },
    task_watch () {
      // 观看时长
      const watch = this.task_daily.watch_room_time_seconds/60
      let left 
      if (watch >= 65) {
        return false
      } else if (watch >= 35) {
        left = 65 - watch
      } else if (watch >= 20) {
        left = 35 - watch
      } else if (watch >= 10){
        left = 20 - watch
      } else {
        left = 10 - watch 
      }
      return Math.floor(left * 100) / 100
    },
    task_wtach_jdt () {
      // 观看时长进度条
      const min = Math.floor(this.task_daily.watch_room_time_seconds/60* 100) / 100
      if (min >= 65) {return 'width: 100%'}
      else if (min <= 10) {return 'width: 0%'}
      else if (min > 10 && min <= 20) {return `width: ${(min - 10) * 15 / 10 + 15}%`}
      else if (min > 20 && min <= 35) {return `width: ${(min - 20) * 15 / 15 + 43}%`}
      else if(min > 35 && min < 65) {return `width: ${(min - 35) * 15 / 30 + 71}%`}
      else {return 'width: 0'}

      // 10 - 20 15% 30%
      // 20 - 35 43% 58%
      // 35 - 65 71% 86%
    },
    version(){
      // 客户端版本小于2.3.1.15
      return this.neteasecloud && _.compareVersion(this.devInfo.app_version || '0', '2.3.1.15') < 0         
    }
  },
  created(){
    this.$store.dispatch('postBehaviors', {
      action: '2021summer-red'
    });

    if (_.getQuerys('inroom')) {
      this.isInRoom = true
    }
    this.$store.dispatch('getDevInfo').then(()=>{})

    window.history.replaceState && window.history.replaceState({},'',location.pathname + '/#/red');

  },
  mounted() {
    this.$http.get(api.getRedUserInfo()).then((res)=>{
      this.task_daily = res
    })   
  },
  methods: {
    closeDraw(){
      if (this.isShowDataurl) {
        this.isShowDataurl = !this.isShowDataurl
        this.dataURL = ''
        return
      }
      document.documentElement.style.cssText = "overflow-y:auto";
      this.$closeweb()
    },
    changeType(type) {
      this.curRedTab = type
    },    
    showpopEvent(type) {
      if (!type) {
        this.showpop = {}
        document.documentElement.style.cssText = "overflow-y:auto";
        return
      }

      this.$set(this.showpop, 'mask', true)
      this.$set(this.showpop, type, true)
      document.documentElement.style.cssText = "overflow: hidden";
    },
    toplay(status){
      // 去完成 -- 要判断是否在房间中
      // 2、排行榜-去一起玩
      if (!status) return

      if (this.isInRoom) {
        this.$toast({
          css: 'toast-red',
          text: '您已在房间中',
          type: 'fail'
        });
        return 
      } else if (this.neteasecloud){
        
        pagebus.sendMsg({
          op: 'action',
          action: 'topage',
          params: {
              path: '/live'
          }
        });
        window.NCGJsBridge.quit();
      } else {
        this.$http.get(api.getAuthTokenCG()).then((res) => {
          location.href = `${process.env.VUE_APP_HOME_URL}?token=${res.auth_token}#/live`;
        }).catch(() => {
          location.href = `${process.env.VUE_APP_HOME_URL}/#/live`;
        });
      }

      this.$store.dispatch('postBehaviors', {
        action: 'redbag_live'
      })

    },
    closeWindow(){
      window.NCGJsBridge.quit();
    },
    toupgrade(){
      pagebus.sendMsg({
        op: 'action',
        action: 'topage',
        params: {
            path: '/setting'
        }
      });
      window.NCGJsBridge.quit();
    }
    
  }
}
</script>